import { Alert, AlertIcon, Box, Center, Flex, Spinner } from "@chakra-ui/react";
import React from "react";

type Props = {
  isLoading: boolean;
  data: any;
  error: unknown;
  children: React.ReactNode;
};

const QueryStateWrapper = ({ isLoading, data, error, children }: Props) => {
  if (isLoading) {
    return (
      <Center p={8}>
        <Spinner />
      </Center>
    );
  } else if (error instanceof Error) {
    return (
      <Center>
        <Alert status="error">
          <AlertIcon />
          {error.message}
        </Alert>
      </Center>
    );
  } else if (data !== undefined) {
    return (
      <Flex direction="column" flex={1}>
        {children}
      </Flex>
    );
  }

  return null;
};

export default QueryStateWrapper;
